import { render, staticRenderFns } from "./SaleEntity.vue?vue&type=template&id=91104ee2&scoped=true"
import script from "./SaleEntity.vue?vue&type=script&lang=js"
export * from "./SaleEntity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91104ee2",
  null
  
)

export default component.exports